import React from 'react';
import PropTypes from 'prop-types';
import { FDStack } from '@facet-wealth/design';
import SmartAutoCustomizationGroup from './SmartAutoCustomizationGroup';

const SmartAutoCustomizationGroups = ({
  collection,
}) => {
  return (
    <FDStack direction={'column'} spacing={2}>
      {collection.resources().list().map((groupResource) => {
        return (
          <SmartAutoCustomizationGroup
            key={groupResource.id()}
            groupResource={groupResource}
          />
        );
      })}
    </FDStack>
  );
};

SmartAutoCustomizationGroups.propTypes = {
  collection: PropTypes.object.isRequired,
};

export default SmartAutoCustomizationGroups;
